<template>
  <div :data-id="question.id" :data-type="`${question.typeEnum}-${question.type}`">
    <template v-if="question.image != '0'">
      <b-row align-v="center">
        <b-col :cols="9">
          <div v-if="question.content !== null" class="mb-3 exam__question__article">
            <div v-if="question.content" v-html="question.content"></div>
          </div>
        </b-col>
        <b-col :cols="3" class="text-center">
          <b-img-lazy thumbnail v-if="question.image != '0'" :src="cdnUrl + question.image" width="256"></b-img-lazy>
        </b-col>
      </b-row>
    </template>
    <template v-else>
      <div v-if="question.content !== null" class="mb-3 exam__question__article">
        <div v-if="question.content" v-html="question.content"></div>
      </div>
      <div v-if="editable">
      </div>
      <div v-else>
        <div v-if="question.explain" v-html="question.explain"></div>
      </div>
    </template>
    <template v-if="question.type == 104">
      <b-row class="d-flex flex-wrap align-items-center" align-h="center">
        <b-col xs="6" md="6"
          align-self="center"
          v-for="(image, indexImage) in getImageList"
          :key="indexImage"
          class="align-middle"
        >
          <div class="text-center mb-3">
            <b-img-lazy thumbnail :src="cdnUrl + image.image" width="128"></b-img-lazy>
            <div>
              <span class="mr-3" v-if="image.key">{{ image.key }}.</span>
              <span class="mr-3" v-else>{{ (indexImage + 1 + 9).toString(36).toUpperCase() }}. </span>
            </div>
          </div>
        </b-col>
      </b-row>
    </template>
    <template v-for="childQuestion in question.children">
      <template v-if="editable">
        <QuestionSingle :key="childQuestion.id" :ref="`question-item-${childQuestion.id}`" :id="`item-${childQuestion.number}`" :data-id="childQuestion.id" :data-type="`${childQuestion.typeEnum}-${childQuestion.type}`" class="question__item" :parent="question" :question="childQuestion" :editable="true" v-on:selectAnswer="selectAnswer" :response="null" :isAudioPlayable="false" :isExplain="isExplain"/>
      </template>
      <template v-else>
        <QuestionSingle :key="childQuestion.id" :id="`item-${childQuestion.number}`" :data-id="childQuestion.id" :data-type="`${childQuestion.typeEnum}-${childQuestion.type}`" class="question__item" :parent="question" :question="childQuestion" :editable="false" :response="getQuestionResponse(childQuestion.id)" :isAudioPlayable="false"  :isExplain="isExplain"/>
      </template>
    </template>
  </div>
</template>

<script>
import { APP_CONFIG } from '@/utils/constants'
import QuestionSingle from './QuestionSingle'

export default {
  name: 'QuestionGroup',
  props: {
    question: Object,
    response: Array,
    editable: Boolean,
    isAudioPlayable: Boolean,
    isExplain: Boolean
  },
  data() {
    return {
      cdnUrl: APP_CONFIG.cdnUrl,
      audioPlayer: null,
      audioList: [],
      isPlayable: true
    }
  },
  components: {
    QuestionSingle,
  },
  computed: {
    questionTemplate() {
      switch (this.question.type) {
        // Reading
        case 103:
          return 'QuestionReadingGroupText'

        case 104:
          return 'QuestionReadingGroupImage'

        // Listening
        case 155:
          return 'QuestionListeningGroupSelect'
      }

      return null;
    },
    getImageList() {
      if (this.question.images) {
        return JSON.parse(this.question.images)
      }

      return []
    }
  },
  methods: {
    fillQuestionNumber() {
      if (this.question.content != null) {
        const regex = /\{\{CAU_HOI\}\}/ig;
        const matches = regex.exec(this.question.content)

        if (matches) {
          this.question.children.forEach(item => {
            this.question.content = this.question.content.replace('{{CAU_HOI}}', `[${item.number}]`)
          })
        }
      }
    },
    getQuestionResponse(id) {
      let answer = null
      
      if (this.response) {
        this.response.forEach(item => {
          if (item.question_id === id) {
            answer = item
          }
        })
      }

      return answer
    },
    selectAnswer(dataAnswer) {
      this.$emit('selectAnswer', dataAnswer)
    },

    playAudio() {
      if (this.audioList.length) {
        let audioPath = this.audioList.shift();
        this.audioPlayer = null;
        this.audioPlayer = new Audio(this.cdnUrl + audioPath.path);
        
        this.isPlayable = false;

        this.audioPlayer.play();
        
        this.audioPlayer.onended = () => {
          this.playAudio();
        };
      } else {
        this.isPlayable = true;
      }
    }
  },
  mounted() {
    this.fillQuestionNumber();

    if (!this.isAudioPlayable) {
      this.isPlayable = false;
    }

    var div = document.createElement("div")
    div.innerHTML = this.question.content

    if (!div.innerText.trim()) {
      this.question.content = null
    }

    if (this.question.audio != "0") {
      this.audioList.push({
        type: "question",
        path: this.question.audio
      });
    }


      
    this.question.children.forEach(childQuestion => {
        if (childQuestion.audio != "0") {
          this.audioList.push({
            type: "question",
            path: childQuestion.audio
          });
        }

        childQuestion.answers.forEach(itemChildQuestion => {
          if (itemChildQuestion.attachment_audio != "0" && itemChildQuestion.attachment_audio != null) {
            this.audioList.push({
              type: "question",
              path: itemChildQuestion.attachment_audio
            });
          }
        });
    });
    
    this.playAudio();
  },
  beforeDestroy() {
    if (this.audioPlayer) {
      this.audioPlayer.pause();
      this.audioPlayer = null;
    }
  },
  watch: {
    isAudioPlayable: function() {
      if (this.isAudioPlayable) {
        //
      } else {
        if (this.audioPlayer) {
          this.audioPlayer.pause();
          this.audioPlayer = null;
        }
      }
    }
  }
}
</script>
